import React, {FC} from "react";

interface BAvatarData {
    className?: any;
    size?: any;
}

const BAvatar: FC<BAvatarData> = ({className = "", size = 20}) => {
    return (
        <React.Fragment>
            <figure className={`bs-icon-avatar ${className}`}>
                <div className="mx-auto">
                    <img
                        src={`${process.env.REACT_APP_BASE_URL}/tokens/img/${process.env.REACT_APP_BASE_UNIT}.png`}
                        alt="OpenScan.ai"
                        className="xdc-nav__logo logo-light"
                        style={{width: `${size}px`, height: `${size}px`}}
                    />
                </div>
            </figure>
        </React.Fragment>
    );
};
export default BAvatar;
